import { render, staticRenderFns } from "./HostAfricaSplaLicenceModal.vue?vue&type=template&id=26ffc21c&"
import script from "./HostAfricaSplaLicenceModal.vue?vue&type=script&lang=js&"
export * from "./HostAfricaSplaLicenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports